import React, { Suspense, lazy } from 'react';
import { Layout, Menu, Icon } from 'antd';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import lifecycle from 'recompose/lifecycle';
import { Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import AppLayout from 'components/Layout';

import { actions } from 'ducks/user';

const { Sider } = Layout;
const { Item } = Menu;
const enhanceTrigger = compose(
  withState('collapsed', 'setCollapsed', false),
  withState('mode', 'setMode', 'inline'),
  withHandlers({
    onCollapse: ({ setCollapsed, setMode }) => (collapsed) => {
      setCollapsed(collapsed);
      setMode(collapsed ? 'vertical' : 'inline');
    }
  }),
  mapProps((props) => {
    const { mode, children, setCollapsed, setMode, ...siderProps } = props;
    return {
      siderProps,
      menuProps: { mode },
      children: props.children
    }
  }),
  connect((state) => ({ location: state.router.location }), { push }),
);

const EnhancedSiderMenu = enhanceTrigger(({ siderProps, menuProps, children, push, location }) => {
  return (
    <Sider {...siderProps}>
      <div className="logo"><span>TakeMeTour<br/>Partner Portal</span></div>
      <Menu theme="dark" { ...menuProps }
        selectedKeys={[location.pathname]}
        onClick={(item) => push(item.key)}
      >
        {children}
      </Menu>
    </Sider>
  )
});

const paths = [
  {
    path: '/dashboard',
    component: lazy(() => import(/* webpackChunkName: "dashboard.page" */'./pages/Dashboard'))
  },
  {
    path: '/payment-method',
    component: lazy(() => import(/* webpackChunkName: "payment-method.page" */'./pages/PaymentMethod'))
  },
  {
    path: '/report',
    component: lazy(() => import(/* webpackChunkName: "payment-method.page" */'./pages/Report'))
  },
  // {
  //   path: '/booking',
  //   component: lazy(() => import(/* webpackChunkName: "booking.page" */'./pages/Booking'))
  // },
  {
    path: '/insight',
    component: lazy(() => import(/* webpackChunkName: "insight.page" */'./pages/Insight'))
  },
  {
    path: '/logout',
    component: lazy(() => import(/* webpackChunkName: "logout.page" */'./pages/Logout'))
  },
  {
    path: '/',
    component: lazy(() => import(/* webpackChunkName: "login.page" */'./pages/Login'))
  },
]

export const Routes = () => (
  <Layout className="main-layout ant-layout-has-sider">
    <EnhancedSiderMenu collapsible className="sider" breakpoint="lg">
      <Item key="/dashboard">
        <Icon type="bar-chart" /> <span className="nav-text">Dashboard</span>
      </Item>
      <Item key="/payment-method">
        <Icon type="form" /> <span className="nav-text">Payment method</span>
      </Item>
      <Item key="/insight">
        <Icon type="profile" /> <span className="nav-text">Insight</span>
      </Item>
      <Item key="/report">
        <Icon type="file-text" /> <span className="nav-text">Report</span>
      </Item>
      <Item key="/logout" selected>
        <Icon type="poweroff" /> <span className="nav-text">Logout</span>
      </Item>
    </EnhancedSiderMenu>
    <AppLayout>
      <Suspense fallback={<Icon type="loading" />}>
        {paths.map(path => (
          <Route key={path.path} path={path.path} exact component={path.component} />
        ))}
      </Suspense>
    </AppLayout>
  </Layout>
)

const enhanceRoute = compose(
  withRouter,
  connect(null, { getMe: actions.getMe }),
  lifecycle({
    componentDidMount() {
      this.props.getMe();
    }
  })
)

export default enhanceRoute(Routes);



// WEBPACK FOOTER //
// ./src/Routes.js